import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cms-layout',
  templateUrl: './cms-layout.component.html',
  styleUrls: ['./cms-layout.component.css']
})
export class CmsLayoutComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
   
  }

}
